import React, {useEffect, useState} from 'react';
import {Card, Col, Container, Row} from 'react-bootstrap';
import * as ModelsWorkflowInbox from '../../models/workflow/WorkflowInbox';
import {useVirtualTableScrollbar} from 'common/hooks';
import { ReportTable } from './ReportTable';
import { ReportCard } from './ReportCard'

var imgHeader = require('../../assets/image/report-header.png');

type Align = 'left' | 'center' | 'right';

interface Props {
    JSONReportList: ModelsWorkflowInbox.JSONReportList;
}

const ReportInformation: React.FC<Props> = ({ JSONReportList }) => {
    const [isLoading, setIsLoading] = useState(true);

    const {
        tableContainerRef,
        virtualTableContainerRef,
        virtualTableRef,
        tableRefCallback
    } = useVirtualTableScrollbar();

    useEffect(() => {
        if (JSONReportList?.ListDataItem) {
            setIsLoading(false);
        }
    }, [JSONReportList]);

    useEffect(() => {
        //console.log(JSONReportList?.ListCardItem);
        //if (JSONReportList?.ListCardItem) {
        //    setIsLoading(false);
        //}
    }, []);

    const renderNoDataMessage = () => (
        <div className="text-center" >
            <label>ไม่พบข้อมูล..</label>
        </div>
    );

    const renderColumnData = (columns: ModelsWorkflowInbox.ColoumList[]) => (
        <table
            className="text-left"
            style={{ width: '100%' }}
        >
            <tbody>
                {columns.map((data, idx) => (
                    <tr key={idx}>
                        <td style={{ width: '20%' }}>
                            <label>
                                <b>{data.label}:</b>
                            </label>
                        </td>
                        <td style={{ width: '80%' }}>{data.value}</td>
                    </tr>
                ))}
            </tbody>
        </table>
    );

    const renderRowData = (rows: ModelsWorkflowInbox.DataHeader['row']) =>
        rows?.map((data, idx) => (
            <Row
                key={idx}
                className="mt-2 mb-2"
            >
                {data.column.map((item, ids) => (
                    <Col
                        key={ids}
                        lg="3"
                        className="table-hover"
                    >
                        <Row>
                            <Col
                                lg="5"
                                className="font-weight-bold text-dark"
                            >
                                {item.label + ' :'}
                            </Col>
                            <Col lg="7">{item.value}</Col>
                        </Row>
                    </Col>
                ))}
            </Row>
        ));

    const renderDataHeader = () => {
        const { DataHeader } = JSONReportList;
        const hasColumns = DataHeader?.column?.length > 0;
        const hasRows = (DataHeader?.row?.length ?? 0) > 0;

        return (
            <Row>
                <Col>
                    <Card style={{
                            borderRadius: '15px',
                            background: 'none',
                            border: 'none',
                        }}
                    >
                        <Card.Header
                            style={{
                                backgroundColor: '#FAEDC4',
                                border: 'none',
                                borderTopLeftRadius: '15px',
                                borderTopRightRadius: '15px'
                            }}
                        >
                            <Row>
                                    <img
                                        src={imgHeader}
                                        style={{
                                            marginLeft: '16px',
                                            marginRight: '16px',
                                            marginTop: '4px',
                                            marginBottom: '4px',
                                            width: '20px',
                                            height: '20px'
                                        }}
                                        alt="file"
                                    />
                                    <p style={{
                                        display: 'flex',
                                        alignItems: 'center'
                                    }}>
                                        <b>Header</b>
                                    </p>
                            </Row>
                        </Card.Header>
                        <Card.Body
                            style={{
                                border: '1px solid #D9D9D9',
                                borderBottomLeftRadius: '15px',
                                borderBottomRightRadius: '15px',
                                borderTop: 'none'
                            }}
                        >
                            {!hasColumns && !hasRows && renderNoDataMessage()}

                            {hasColumns && !DataHeader.row && (
                                <Row>
                                    <Col lg={12}>
                                        {renderColumnData(DataHeader.column)}
                                    </Col>
                                </Row>
                            )}

                            {hasRows && (
                                <Row>
                                    <Col lg={12}>
                                        {renderRowData(DataHeader.row)}
                                    </Col>
                                </Row>
                            )}
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        );
    };

    const hasDataItems = JSONReportList?.ListDataItem?.length > 0;
    const hasCardItems = JSONReportList?.ListCardItem?.length > 0;
    
    return (
        <Container
            fluid
            className="mt-3"
        >
            {renderDataHeader()}

            {!isLoading &&
                hasDataItems &&
                JSONReportList.ListDataItem.map((listItem, index) => (
                    <ReportTable
                        key={index}
                        disabledTips={index === 0}
                        listItem={listItem}
                    />
                ))}
            {!isLoading &&
                hasCardItems &&
                JSONReportList.ListCardItem.map((listItem, index) => (
                    <ReportCard
                        key={index}
                        listItem={listItem}
                    />
                ))}
        </Container>
    );
};

export default ReportInformation;
